module.exports = __webpack_public_path__ + "static/sport/toast-1.2921633.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/toast-1.png
// module id = sZwO
// module chunks = 0